import { apiClient } from "./client";

export interface AuditLogEntry {
  id: string;
  action: string;
  entity_type: string | null;
  entity_id: string | null;
  details: Record<string, unknown> | null;
  created_at: string;
  actor: { id: string; email: string; full_name: string | null; role: string } | null;
}

export async function listAuditLog(before?: string): Promise<{ entries: AuditLogEntry[] }> {
  const { data } = await apiClient.get<{ entries: AuditLogEntry[] }>("/audit-log", {
    params: before ? { before } : undefined,
  });
  return data;
}
